import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DbmAdditionalOptionsModule } from './dbm-additional-options/dbm-additional-options.module';
import { DbmBoxListModule } from './dbm-box-list/dbm-box-list.module';
import { DbmEditModule } from './dbm-edit/dbm-edit.module';
import { DbmListModule } from './dbm-list/dbm-list.module';
import { DbmList2Module } from './dbm-list2/dbm-list2.module';
import { DbmMasterDetailListModule } from './dbm-master-detail-list/dbm-master-detail-list.module';
import { DbmTimeframeModule } from './dbm-timeframe/dbm-timeframe.module';
import { DbmAdditionalProprtiesOptionsModule} from './dbm-proprties-additional-options/dbm-additional-proprties.module'
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { DbmFileUploadModule } from '@app/shared/components/dbm-components/dbm-file-upload/dbm-file-upload.module';
import { MatAutocompleteModule } from '@angular/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MatInputModule} from '@angular/material/input';

@NgModule({
    imports: [
        CommonModule,
        DbmAdditionalProprtiesOptionsModule,
        DbmAdditionalOptionsModule,
        DbmBoxListModule,
        DbmEditModule,
        DbmListModule,
        DbmList2Module,
        DbmMasterDetailListModule,
        DbmTimeframeModule,
        DbmFileUploadModule,
        DirectivesModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule    ],    
    exports: [
        DbmEditModule,
        DbmBoxListModule,
        DbmListModule,
        DbmList2Module,
        DbmMasterDetailListModule,
        DbmTimeframeModule,
        MatAutocompleteModule
    ]
})
export class DbmComponentsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-components.module.ts